export default function loadSearch() {
  return import("./header-search-interactive");
}
